const socialIconGroupName = 'main:help:brc::brcSocialIconClick';

const pageNames =  Object.freeze({

  brcHomePage: {
        //on brc main page
        /*
         req.tracking.addClientSideFptiData('page', 'main:help:brc::brcHome:::');
         req.tracking.addClientSideFptiData('pgrp', 'main:help:brc::brcHome');
         req.tracking.addClientSideFptiData('tmpl', 'brcHome.dust');
         */
  },

  brcCategoriesPage: {
        //brc categories page - category ID
        /*
         req.tracking.addClientSideFptiData('page', `main:help:brc::brcCategories:${refID}:::`);
         req.tracking.addClientSideFptiData('pgrp', `main:help:brc::brcCategories:${refID}`);
         req.tracking.addClientSideFptiData('tmpl', 'brcCategories.dust');
         */
  },

  brcArticlePage: {
        //brc Article page - Article ID
       /*
        req.tracking.addClientSideFptiData('page', `main:help:brc::brcArticle:${slugID}:::`);
        req.tracking.addClientSideFptiData('pgrp', `main:help:brc::brcArticle:${slugID}`);
        req.tracking.addClientSideFptiData('tmpl', 'brcArticle.dust');
        */
  },
  brcTileClick: {
        //on brc main page tiles click -> data-pa-click={'tileClick|'+tile.url_slug}
  },
  brcHomeVideoClick: {
        //on brc main page tiles click -> className={"brcHomeVideoClick|"+slugId+"| triangle-right"} PENDING CHECK with FPTI Team
        // pageGroupName: 'main:help:brc::brcHomeVideoClick',
        // pageName: 'main:help:brc::brcHomeVideoClick:::',
  },
  brcSearchClick: {
        //on search click
        // two beacons - update it
  },

  brcVideoIconClick: {
        //brc Article page - Article ID -> main:help:brc::brcHome|brcHomeVideoClick|8-Common-Ecommerce-Scams-To-Avoid| triangle-right

  },
  brcTopicClick: {
        //brc Home page - topic ID -> data-pa-click = {"brcTopicClick|"+topic.ref_key}
        /* pageGroupName: 'main:help:brc::brcTopicClick',
        pageName: 'main:help:brc::brcTopicClick:::', */
  },
  brcHelpCenterClick: {
        //brc Home page -Help Center
        /*
         link:brcHelpCenterClick
         pglk:main:help:brc::brcHome|brcHelpCenterClick
         pgln:main:help:brc::brcHome:::|brcHelpCenterClick

         brcCommunityClick

         brcResolutionClick

         brcTaxCenterClick

         brcContactUsClick
         */
  },
  brcHomeLoadMoreClick: {
        //brcHomeLoadMoreClick -> data-pa-click={'brcHomeLoadMoreClick|'+this.state.page_size}
  },

  brcScrollUpClick: {
        //brc Article page - Article ID
        /*
         link:brcScrollUpClick
         pglk:main:help:brc::brcHome|brcScrollUpClick
         pgln:main:help:brc::brcHome:::|brcScrollUpClick
         */
  },

  brcSignupClick: {
        //brc email signup
        // Email form yet to hear back from FPTI team
        //on landing home page from it - we must be able to track
        /*
         pglk:main:help:brc::brcHomePage|pypl-btn signup-btn
         pt:Business Resource Center - PayPal
         ru:https://s94483084.t.eloqua.com/e/f2
         */
        // pageGroupName: 'main:help:brc::brcSignupClick',
        // pageName: 'main:help:brc::brcSignupClick:::',
  },

  brcLeftNavTopicClick: {
        //brc leftnav when user clicks on another topic
        //data-pa-click ={`brcLeftNav|L2TopicClick|${category.ref_id}`}
        //data-pa-click={`brcLeftNav|L1TopicClick|${section.ref_id}`}
  },

  brcHomeClickFromCategory: {
        //brc leftnav when user clicks on another topic
      //data-pa-click = {`brcHomeClickFromCategory`}
  },

  brcCategoryListArticleClick: {
        //Article click from list of articles
    pageGroupName: 'main:help:brc::brcCategoryListArticleClick',
    pageName: 'main:help:brc::brcCategoryListArticleClick:::',
  },

  brcCategoryLoadMoreClick: {
        //on click of load more in category page
    pageGroupName: 'main:help:brc::brcCategoryLoadMoreClick',
    pageName: 'main:help:brc::brcCategoryLoadMoreClick:::',
  },

  brcTwitterClick: {
    pageGroupName: socialIconGroupName,
    pageName: 'main:help:brc::brcTwitterClick:::',
  },

  brcLinkedInClick: {
    pageGroupName: socialIconGroupName,
    pageName: 'main:help:brc::brcLinkedInClick:::',
  },

  brcFacebookClick: {
    pageGroupName: socialIconGroupName,
    pageName: 'main:help:brc::brcFacebookClick:::',
  },

  brcEmailClick: {
    pageGroupName: socialIconGroupName,
    pageName: 'main:help:brc::brcEmailClick:::',
  },

  brcGooglePlusClick: {
    pageGroupName: socialIconGroupName,
    pageName: 'main:help:brc::brcGoogleplusClick:::',
  },

  brcArticleDownload: {
        //To be updated after Loga's meeting
  },

  brcFAQsClick: {
    pageGroupName: 'main:help:brc::brcFAQsClick',
    pageName: 'main:help:brc::brcFAQsClick:::',
  },
  brcebooksClick: {
    pageGroupName: 'main:help:brc::brcebooksClick',
    pageName: 'main:help:brc::brcebooksClick:::',
  },
  brcpromotionsClick: {
    pageGroupName: 'main:help:brc::brcpromotionsClick',
    pageName: 'main:help:brc::brcpromotionsClick:::',
  },
  brcfeaturedClick: {
    pageGroupName: 'main:help:brc::brcfeaturedClick',
    pageName: 'main:help:brc::brcfeaturedClick:::',
  },

  brcRelatedStoriesClick: {
    pageGroupName: 'main:help:brc::brcRelatedStoriesClick',
    pageName: 'main:help:brc::brcRelatedStoriesClick:::',
  },

});

export default pageNames;
